<template>
  <fragment>
    <AppBody title="Vendas" subtitle="Listagem de Vendas">
      <v-form @submit.prevent="filterVendas" class="search-forms">
        <v-row>
          <v-col cols="3">
            <label class="input-labels"> Nome do consumidor </label>
            <v-text-field
              solo
              placeholder="Insira o nome do consumidor"
              v-model="$vendas.filter.nome_consumidor"
              type="text"
              data-cy="nome-consumidor"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> E-mail do consumidor </label>
            <v-text-field
              solo
              placeholder="Insira o e-mail do consumidor"
              v-model="$vendas.filter.email_consumidor"
              type="text"
              data-cy="email-consumidor"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Código do pedido </label>
            <v-text-field
              solo
              placeholder="Insira o código do pedido"
              v-model="$vendas.filter.cod_pedido"
              type="text"
              data-cy="codigo-pedido"
              class="textinput"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Status </label>
            <v-select
              height="48"
              :items="$vendas.status_pedido"
              item-text="value"
              item-value="key"
              dense
              solo
              data-cy="status"
              class="textinput"
              v-model="$vendas.filter.status"
              placeholder="Selecione o status"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clear-icon="mdi-close-circle-outline"
              clearable
              @click:clear="clearFilterFields('status')"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <label class="input-labels"> Data inicial do pedido </label>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dtInicial"
                  append-icon="mdi-calendar-blank-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  data-cy="data-inicial"
                  class="textinput"
                  :placeholder="placeholderData"
                  :color="$config.dados.corinputs"
                  clearable
                  @click:clear="clearFilterFields('data_inicio')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="$vendas.filter.data_inicial"
                :active-picker.sync="activePicker"
                min="1950-01-01"
                @change="save"
                locale="pt"
                :header-color="$config.dados.corinputs"
                landscape
                :color="$config.dados.corinputs"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Hora Inicial</label>
            <v-text-field
              solo
              v-model="$vendas.filter.hora_inicial"
              type="tel"
              data-cy="hora-inicial"
              class="textinput"
              :placeholder="placeholderHora"
              v-mask="'##:##'"
              append-icon="mdi-clock-outline"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Data final do pedido </label>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dtFinal"
                  append-icon="mdi-calendar-blank-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  data-cy="data-final"
                  class="textinput"
                  :placeholder="placeholderData"
                  :color="$config.dados.corinputs"
                  clearable
                  @click:clear="clearFilterFields('data_final')"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="$vendas.filter.data_final"
                :active-picker.sync="activePicker2"
                min="1950-01-01"
                @change="save2"
                locale="pt"
                :header-color="$config.dados.corinputs"
                :color="$config.dados.corinputs"
                landscape
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Hora Final</label>
            <v-text-field
              solo
              v-model="$vendas.filter.hora_final"
              type="tel"
              data-cy="hora-final"
              class="textinput"
              :placeholder="placeholderHora"
              v-mask="'##:##'"
              append-icon="mdi-clock-outline"
            >
            </v-text-field>
          </v-col>
          <v-col cols="3" v-if="isAdmin">
            <label class="input-labels"> Regional </label>
            <v-select
              height="48"
              :items="$loja_gerenciar.regionais"
              item-text="nome"
              item-value="idregional"
              dense
              solo
              data-cy="regional"
              class="textinput"
              v-model="$vendas.filter.regional"
              placeholder="Selecione a regional"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear="clearFilterFields('regional')"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Forma de pagamento </label>
            <v-select
              height="48"
              :items="$relatorios_sinteticos.formas_de_pagamento"
              item-text="key"
              item-value="value"
              dense
              solo
              data-cy="forma-pagamento"
              class="textinput"
              v-model="$vendas.filter.forma_pagamento"
              placeholder="Selecione a forma de pgto"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear="clearFilterFields('forma_de_pagamento')"
            ></v-select>
          </v-col>
          <v-col cols="3" v-if="!isAdmin">
            <label class="input-labels"> Canal de Vendas </label>
            <v-select
              height="48"
              :items="$relatorios_sinteticos.canais_de_venda"
              item-text="value"
              item-value="key"
              dense
              solo
              data-cy="canal-vendas"
              class="textinput"
              v-model="$vendas.filter.canal_de_vendas"
              placeholder="Selecione o canal de vendas"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear="clearFilterFields('canal_de_venda')"
            ></v-select>
          </v-col>
          <v-col cols="3" v-if="isAdmin">
            <label class="input-labels"> Canal de Vendas </label>
            <v-select
              height="48"
              :items="$relatorios_sinteticos.canais_de_venda"
              item-text="value"
              item-value="key"
              dense
              solo
              data-cy="canal-de-vendas"
              class="textinput"
              v-model="$vendas.filter.canal_de_vendas"
              placeholder="Selecione o canal de vendas"
              :color="$config.dados.corinputs"
              :item-color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear="clearFilterFields('canal_de_venda')"
            ></v-select>
          </v-col>
          <v-col cols="2" class="align-self-end ml-auto">
            <v-btn
              height="48"
              data-cy="filtrar"
              class="button btn-size btn-border"
              type="submit"
              :loading="$vendas.loading_button"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        class="table-body"
        no-data-text="Não há registro de vendas."
        loading-text="Buscando informações..."
        :headers="headers"
        :items="orderedVendas"
        :items-per-page="10"
        :loading="$vendas.loading_vendas"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Vendas por página:',
        }"
      >
        <template v-slot:item.data_pagamento="{ item }">
          {{ item.data_pagamento | dthr_pt_br }}
        </template>
        <template v-slot:item.valor="{ item }">
          {{ item.valor | moeda }}
        </template>
        <template v-slot:item.data_criacao="{ item }">
          {{ item.data_criacao | dthr_pt_br }}
        </template>
        <template v-slot:item.form_pag="{ item }">
          {{ item.forma_pag === "QRCODE" ? "PIX" : item.forma_pag }}
        </template>
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    item.idpedido_marketplace
                      ? openModalMkt(
                          item.idpedido_marketplace,
                          item.ano_mes,
                          'modal-body-vendas-detalhes',
                          item.idconsumidor
                        )
                      : openModal(
                          item.idpedido,
                          item.sequenciador,
                          'modal-body-vendas-detalhes',
                          item.idconsumidor
                        )
                  "
                  class="mr-2"
                >
                  <v-icon>mdi-book-open-outline</v-icon>
                </v-btn>
              </template>
              <span>Detalhes</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :color="$config.dados.corinputs"
                  :disabled="
                    item.canal_venda === 'PDV_POS' || item.status !== 'Pago'
                  "
                  @click="cancelOrder(item)"
                >
                  <v-icon>mdi-basket-remove-outline</v-icon>
                </v-btn>
              </template>
              <span>Cancelar pedido</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <SalesDetailsDialog />
      <ModalConfirmacao
        :warnText="'Obs: O status do pedido será alterado somente quando a adquirente cancelar o pagamento.'"
        :textModal="'Deseja realmente cancelar este pedido?'"
        @callback="confirmCancelOrder"
      />
    </AppBody>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import { ENDPOINTS } from "@/services/Endpoints.js";
import _ from "lodash";
export default {
  name: "Sales",
  components: {
    SalesDetailsDialog: () =>
      import("@/components/vendas/SalesDetailsDialog.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  metaInfo: {
    title: "Vendas | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Vendas | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      activePicker4: null,
      date: null,
      hour: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dtInicial: "",
      dtFinal: "",
      horaInicial: "",
      horaFinal: "",
      placeholderData: "dd/mm/aa",
      placeholderHora: "hh:mm",
      regional: [],
      form_pag: [],
      cnl_venda: [],
      agentes: [],
      pdvs: [],
      order_type: "",
      idpedido: "",
      idpedido_mktplace: "",
      filter: {
        nome_consumidor: "",
        email_consumidor: "",
        cod_pedido: "",
        status: "",
        data_inicial: "",
        hora_inicial: "",
        data_final: "",
        hora_final: "",
        regional: "",
        forma_pagamento: "",
        loja: "",
        canal_de_vendas: "",
        agente: "",
        ponto_de_venda: "",
        error: {
          loja: [],
        },
      },
      cancellation: {
        idconsumidor: "",
        idloja: "",
        loja: "",
        data_pagamento: "",
      },
      mktplace_cancellation: {
        idconsumidor: "",
        idloja: "",
        lojas: "",
        ano_mes: "",
        data_pagamento: "",
      },
      // header da tabela
      headers: [
        {
          text: "Código do Pedido",
          align: "center",
          sortable: false,
          value: "pedido",
          width: 160,
        },
        {
          text: "Consumidor",
          align: "center",
          sortable: true,
          value: "nome",
          width: 180,
        },
        {
          text: "E-mail",
          align: "center",
          sortable: false,
          value: "email",
          width: 60,
        },
        {
          text: "Loja",
          align: "center",
          sortable: true,
          value: "loja",
          width: 120,
        },
        {
          text: "Canal de Venda",
          align: "center",
          sortable: false,
          value: "canal_venda",
          width: 140,
        },
        {
          text: "Forma de pagamento",
          align: "center",
          sortable: true,
          value: "form_pag",
          width: 200,
        },
        {
          text: "Parcelas",
          align: "center",
          sortable: true,
          value: "parcelas",
          width: 100,
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          width: 90,
        },
        {
          text: "Data de pagamento",
          align: "center",
          sortable: false,
          value: "data_pagamento",
          width: 140,
        },
        {
          text: "Valor",
          align: "center",
          sortable: true,
          value: "valor",
          width: 80,
        },
        {
          text: "Data de criação",
          align: "center",
          sortable: true,
          value: "data_criacao",
          width: 160,
        },
        {
          text: "Itens",
          align: "center",
          sortable: true,
          value: "qtd_itens_pedido",
          width: 70,
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          fixed: true,
          value: "actions",
        },
      ],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
    "$store.getters.storeSequencial"() {
      this.filterVendas();
    },
  },
  methods: {
    filterVendas() {
      this.$vendas.filtroVendas();
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
      this.dtInicial = this.$config.convertDataBR(date);
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.dtFinal = this.$config.convertDataBR(date);
    },
    save3(hour) {
      this.$refs.menu3.save(hour);
      this.horaInicial = hour;
    },
    save4(hour) {
      this.$refs.menu4.save(hour);
      this.horaFinal = hour;
    },
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$vendas.filter.status = "";
          break;
        case "regional":
          this.$vendas.filter.regional = "";
          break;
        case "forma_de_pagamento":
          this.$vendas.filter.forma_pagamento = "";
          break;
        case "loja":
          this.$vendas.filter.loja = "";
          break;
        case "canal_de_venda":
          this.$vendas.filter.canal_de_vendas = "";
          break;
        case "agente":
          this.$vendas.filter.agente = "";
          break;
        case "data_inicio":
          this.$vendas.filter.data_inicial = "";
          this.dtInicial = "";
          break;
        case "data_final":
          this.$vendas.filter.data_final = "";
          this.dtFinal = "";
          break;
        case "hora_inicial":
          this.$vendas.filter.hora_inicial = "";
          this.horaInicial = "";
          break;
        case "hora_final":
          this.$vendas.filter.hora_final = "";
          this.horaFinal = "";
          break;
        default:
          break;
      }
    },
    openModal(pedido, loja, name, idconsumidor) {
      this.$vendas.idconsumidor = idconsumidor;
      this.$vendas.getItensPedido(pedido, loja);
      document.getElementsByClassName(name)[0].style.display = "flex";
    },
    openModalMkt(pedido, ano_mes, name, idconsumidor) {
      this.$vendas.idconsumidor = idconsumidor;
      this.$vendas.getItensPedidoMkt(pedido, ano_mes);
      document.getElementsByClassName(name)[0].style.display = "flex";
    },
    confirmCancelOrder() {
      if (this.order_type === "generic") {
        this.$axios.post(
          this.ENDPOINTS.CANCELAR_PEDIDO + this.idpedido,
          JSON.stringify(this.cancellation)
        );
        return;
      }
      this.mktplace_cancellation.lojas = this.$vendas.lojas_mkt;
      this.$axios.post(
        this.ENDPOINTS.CANCELAR_PEDIDO_MKTPLACE + this.idpedido_mktplace,
        JSON.stringify(this.mktplace_cancellation)
      );
    },
    cancelOrder(order) {
      if (order.idpedido_marketplace !== "") {
        this.$vendas.getItensPedidoMkt(
          order.idpedido_marketplace,
          order.ano_mes
        );
        this.order_type = "marketplace";
        this.idpedido_mktplace = order.idpedido_marketplace;
        this.mktplace_cancellation.idconsumidor = order.idconsumidor;
        this.mktplace_cancellation.idloja = order.idloja;
        this.mktplace_cancellation.ano_mes = order.ano_mes;
        this.mktplace_cancellation.data_pagamento = order.data_pagamento;
        this.$config.modalConfirm = true;
        return;
      }

      this.order_type = "generic";
      this.idpedido = order.idpedido;
      this.cancellation.idconsumidor = order.idconsumidor;
      this.cancellation.idloja = order.idloja;
      this.cancellation.loja = order.sequenciador;
      this.cancellation.data_pagamento = order.data_pagamento;
      this.$config.modalConfirm = true;
    },
  },
  computed: {
    ...mapGetters(["storeSequencial"]),
    orderedVendas() {
      return _.orderBy(this.$vendas.vendas, ["data_criacao"], ["desc", "asc"]);
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
  },
  mounted() {
    if (this.$loja_gerenciar.lojas.length == 0 && this.isAdmin) {
      this.$loja_gerenciar.getAllLojas();
    }
    this.$loja_gerenciar.getRegionais();
    this.$relatorios_sinteticos.getCanaisDeVenda();
    this.$relatorios_sinteticos.getFormasDePagamento();
    this.$vendas.getStatusPedido();
    this.filterVendas();
  },
  destroyed() {
    this.$vendas.limpaFiltros();
  },
};
</script>

<style scoped>
.vendas-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0;
  align-items: center;
  border-width: 0;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.vendas-icon {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
</style>
